import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatChipInputEvent } from '@angular/material/chips';

import { FormService } from '@main-client/src/app/form/form.service';

import includes from 'lodash-es/includes';
import isEqual from 'lodash-es/isEqual';
import remove from 'lodash-es/remove';

@Component({
  selector: 'app-form-template-body',
  templateUrl: './form-template-body.component.html',
  styleUrls: ['./form-template-body.component.scss'],
})
export class FormTemplateBodyComponent implements OnInit {
  @Input() forms: any[];
  @Input() formGroup: UntypedFormGroup;
  @Output() formChange: EventEmitter<any> = new EventEmitter();
  separatorKeysCodes = [ENTER, COMMA, SPACE];

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    if (!this.formGroup) {
      this.formGroup = this.formService.generateFormGroup(this.forms);
    }
    if (this.formGroup) {
      this.formGroup.valueChanges.subscribe((formValue: any) =>
        this.onFormChange(formValue, this.formGroup),
      );
    }
  }

  imageChange(form: any, imageUrl: string): void {
    const update = { [form.updateKey]: imageUrl };
    this.onFormChange(update, this.formGroup);
  }

  onFormChange(update: any, formGroup: any) {
    if (!this.formChange) {
      return;
    }
    this.formChange.emit({ update, formGroup });
  }

  removeChip(chipList: string[], chipToRemove: string) {
    return remove(chipList, (item: string) => isEqual(item, chipToRemove));
  }

  addChipToList(
    chipList: string[],
    updateKey: string,
    event: MatChipInputEvent,
  ) {
    const { input, value } = event;
    if (includes(chipList, value)) {
      this.formGroup.get([updateKey]).setErrors({ isInList: true });
      return;
    }
    if ((value || '').trim()) {
      chipList.push(value.trim());
    }
    input.value = '';
  }

  subFormGroupChange(subFormUpdate: any, formGroup: any) {
    const update = {
      ...subFormUpdate,
      ...this.formGroup.value,
    };
    this.formChange.emit({ update, formGroup });
  }
}
